import { render, staticRenderFns } from "./AgeAverageDetail.vue?vue&type=template&id=62642900&"
import script from "./AgeAverageDetail.vue?vue&type=script&lang=js&"
export * from "./AgeAverageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports